export const MAX_PAGE_SIZE = 1000;

// TODO: Revisit options here to see if they make sense - these are taken from ICM
export const PAGE_SIZE_OPTIONS = [50, 100, 200, 500, MAX_PAGE_SIZE];
